import {connect} from '../../../redux/helpers/helpers';
import {resourceActions} from '../../../redux/reducers/resources/resources-reducer';
import {api} from '@symbolic/lib';
import {singularize} from 'inflection';
import _ from 'lodash';

require('henrybuilt-js-library');

var lib = window.lib;

var resourcesData = {
  pyramid: {
    nodeTypeId: 8,
    nodePropIdToKeyMap: {
      title: 32,
      teamId: 41
    },
    childResourceKeys: ['levels']
  },
  level: {
    nodeTypeId: 9,
    nodePropIdToKeyMap: {
      title: 33, rank: 39
    },
    childResourceKeys: ['blocks']
  },
  block: {
    nodeTypeId: 10,
    nodePropIdToKeyMap: {
      title: 34, description: 35, ownerIds: 36, status: 37, rank: 38, lastActivity: 45
    },
    childResourceKeys: ['initiatives']
  },
  initiative: {
    nodeTypeId: 11,
    nodePropIdToKeyMap: {
      title: 40, isActive: 42, isComplete: 43, isHighPriority: 44
    }
  }
}

_.forEach(resourcesData, (resourceData, key) => resourceData.key = key);

var resourceFor = ({node, childrenMode='direct'}, options={}) => {
  var resourceData = _.find(resourcesData, {nodeTypeId: node.nodeTypeId});

  //props
  var keyedProps = _.mapValues(resourceData.nodePropIdToKeyMap, nodePropId => _.get(node, `props.${nodePropId}`));

  //children

  var children = {};
  var {nodesById, parentMap} = options;

  if (childrenMode !== 'none' && parentMap) {
    var isChild = (fromNodeId, toNodeId) => parentMap[`${fromNodeId}-${toNodeId}`] !== undefined;

    children = lib.object.fromKeys(resourceData.childResourceKeys, childResourceKey => {
      var childResourceData = resourcesData[singularize(childResourceKey)];
      var childResources = lib.waterfall(nodesById, [
        [_.filter, {nodeTypeId: childResourceData.nodeTypeId}],
        [_.filter, n2 => isChild(node.id, n2.id)],
        [_.map, node => resourceFor({node, childrenMode: childrenMode === 'direct' ? 'none' : childrenMode}, options)]
      ]);

      return childResources;
    });
  }

  return {
    ...node,
    ...keyedProps,
    ...children
  };
};

var mixinNodeResource = (Target, resourceKey) => {
  var resourceData = resourcesData[resourceKey];

  class NodeResourceComponent extends Target {
    constructor(props) {
      super(props);

      if (!this.state) this.state = {};

      this.destroy = this.destroy.bind(this);
    }

    static getDerivedStateFromProps(props) {
      var {nodesById, parentMap} = props;
      var state = {...(super.getDerivedStateFromProps && super.getDerivedStateFromProps(props))};
      var node = _.get(props, `nodesById.${props.id}`);

      if (node) {
        var resource = resourceFor({node}, {nodesById, parentMap});

        state[resourceKey] = resource;
      }
      else {
        console.error('node not found', props);
      }

      return state;
    }

    async createChildResource(childResourceKey, props={}) {
      var childResourceData = resourcesData[childResourceKey];

      props = {props: {}, nodeTypeId: childResourceData.nodeTypeId, ...props};

      var node = await api.create('node', _.omit(props, ['id']));

      this.props.trackNodes({nodes: [node]});

      this.props.createEdge({
        props: {fromNodeId: this.id, toNodeId: node.id, type: 'parent'}
      });
    }

    get id() {
      return this.props.id;
    }

    get resource() {
      return this.state[resourceKey];
    }

    async updateProp(key, value) {
      var nodePropId = resourceData.nodePropIdToKeyMap[key];
      var props = {...this.resource.props, [nodePropId]: value};

      this.props.updateNode({id: this.id, props: {props}});
    }

    async destroy(event) {
      var title = _.get(this, 'resource.title');

      if (title) var message = `Are you sure you want to delete the ${_.startCase(resourceKey)}: ${title}?`;
      else var message = `Are you sure you want to delete this ${_.startCase(resourceKey)}?`;

      var shouldDestroy = confirm(message.toLowerCase()); //eslint-disable-line

      if (shouldDestroy) this.props.destroyNode({id: this.id});

      if (event && event.preventDefault) event.preventDefault()
    }
  }

  return connect({
    mapState: ({resources}) => ({nodesById: resources.nodes.byId, parentMap: resources.edges.parentMap}),
    mapDispatch: {..._.extend({}, ..._.values(resourceActions))}
  })(NodeResourceComponent);
}

export {resourcesData, resourceFor, mixinNodeResource};
